/**
 * Permissions plugin (R0)
 *
 * @description Direttiva `v-can` per show/hide dichiarativo basato sui permessi
 *              Spatie forniti dal BE (auth store, `permissions`).
 *
 * Uso:
 *   v-can="'rapportini.view.all'"          — singolo permesso
 *   v-can="['quotes.send', 'quotes.close']" — almeno uno (canAny)
 *
 * NB: la direttiva nasconde l'elemento (display: none) — è UX, non sicurezza:
 * l'enforcement vero resta lato backend (middleware/policy). Per logica più
 * articolata usare direttamente `useAuthStore().can()/canAny()/canAll()`.
 */

import type { App, DirectiveBinding } from 'vue'
import { useAuthStore } from '@/stores/auth'

type CanValue = string | string[]

function applyVisibility(el: HTMLElement, binding: DirectiveBinding<CanValue>): void {
  const auth = useAuthStore()
  const value = binding.value

  const allowed = Array.isArray(value) ? auth.canAny(...value) : auth.can(value)

  if (allowed) {
    // Ripristina l'eventuale display originale salvato al primo mount.
    el.style.display = (el.dataset.vCanDisplay as string) ?? ''
  } else {
    if (el.dataset.vCanDisplay === undefined) {
      el.dataset.vCanDisplay = el.style.display
    }
    el.style.display = 'none'
  }
}

export function registerPermissionsDirective(app: App): void {
  app.directive<HTMLElement, CanValue>('can', {
    mounted: applyVisibility,
    updated: applyVisibility,
  })
}
